
import { Component, Vue } from 'vue-property-decorator';
import ModalDefault from '@/components/ModalDefault.vue';
import ModalDefaultPopupBodyOrientation from '@/components/ModalDefaultPopupBodyOrientation.vue';
import { MessageTypeErrorFaceAction } from '@/components/ModalDefaultPopupBodyErrorFaceAction.vue';
import ScreenOrientationTracker from '@/components/ScreenOrientationTracker.vue';
import { ScreenOrientation } from '@/resources/enum/ScreenOrientation';

@Component({
  components: {
    ModalDefault,
    ModalDefaultPopupBodyOrientation,
    ScreenOrientationTracker
  }
})
export default class Parts extends Vue {
  private get isFaceActionShooting(): boolean {
    return this.$route.name === 'face-action-shooting';
  }

  private get isFaceActionErrorOrientation(): boolean {
    if (this.$route.name !== 'face-action-error') return false;
    const queryErrorFaceAction: string | (string | null)[] | undefined = this.$route.query.face_action_error;
    if (typeof queryErrorFaceAction !== 'string') return false;
    const numberErrorFaceAction: number = Number.parseInt(queryErrorFaceAction, 10);
    return numberErrorFaceAction === MessageTypeErrorFaceAction.InvalidScreenOrientation;
  }

  private get isOpen(): boolean {
    if (this.isFaceActionShooting) return false;
    if (this.isFaceActionErrorOrientation) return false;
    return this.$store.getters['orientation/isInvalidOrientation'];
  }

  private onOrientationChanged(value: ScreenOrientation): void {
    this.$store.commit('orientation/setOrientation', value);
  }
}
